/**
 * 광고등록 필드 안내 STEP 데이터
 *
 * ============================================================
 * 이미지 교체 방법 (상품 URL)
 * ============================================================
 * 파일 위치:
 *   public/images/field-info/product-url-step1.png  (또는 .svg / .jpg)
 *   public/images/field-info/product-url-step2.png
 *   public/images/field-info/product-url-step3.svg  ← STEP3 (현재 임시)
 *
 * png/jpg로 바꿀 경우 아래 image.src 확장자만 맞추면 됩니다.
 * width / height 는 원본 비율에 맞게 조정하세요.
 * ============================================================
 */

export const PRODUCT_URL_INFO = {
  title: "상품 URL 입력 안내",
  steps: [
    {
      id: "product-url-1",
      description: "네이버에 등록할 상품을 검색 후 상품페이지에 들어가주세요.",
      image: {
        // ← STEP1 이미지: public/images/field-info/product-url-step1.*
        src: "/images/field-info/product-url-step1.png",
        alt: "네이버 상품 검색 후 상품페이지 진입",
        width: 480,
        height: 280,
      },
    },
    {
      id: "product-url-2",
      description: "이미지와 같이 상품페이지 상단 주소를 복사해주세요.",
      image: {
        // ← STEP2 이미지: public/images/field-info/product-url-step2.*
        src: "/images/field-info/product-url-step2.png",
        alt: "상품페이지 상단 주소 복사",
        width: 480,
        height: 200,
      },
    },
    {
      id: "product-url-3",
      description:
        "올려줌 사이트에 돌아와서 복사한 주소를 붙여넣기 해주세요.",
      image: {
        // ← STEP3 이미지: public/images/field-info/product-url-step3.*
        src: "/images/field-info/product-url-step3.png",
        alt: "올려줌에 주소 붙여넣기",
        width: 480,
        height: 240,
      },
    },
  ],
};

export const ORIGIN_PRODUCT_URL_INFO = {
  title: "상품 URL 입력 안내",
  steps: [
    {
      id: "origin-product-url-1",
      description:
        "네이버에 등록할 상품을 검색 후 카탈로그 상품 페이지에 들어가주세요.",
      image: {
        // ← STEP1 이미지: public/images/field-info/catalog-url-step1.*
        src: "/images/field-info/catalog-url-step1.png",
        alt: "카탈로그 상품 페이지 진입",
        width: 480,
        height: 280,
      },
    },
    {
      id: "origin-product-url-2",
      description: "카탈로그 상품 페이지에서 등록한 상품 페이지에 들어가주세요.",
      image: {
        // ← STEP2 이미지: public/images/field-info/catalog-product-step2.*
        src: "/images/field-info/catalog-product-step2.png",
        alt: "카탈로그에서 등록 상품 페이지 진입",
        width: 480,
        height: 280,
      },
    },
    {
      id: "origin-product-url-3",
      description: "이미지와 같이 상품페이지 상단 주소를 복사해주세요.",
      image: {
        // ← STEP3 이미지: public/images/field-info/catalog-product-step3.*
        src: "/images/field-info/catalog-product-step3.png",
        alt: "상품페이지 상단 주소 복사",
        width: 480,
        height: 240,
      },
    },
    {
      id: "origin-product-url-4",
      description: "올려줌 사이트에 돌아와서 복사한 주소를 붙여넣기 해주세요.",
      image: {
        // ← STEP4 이미지: public/images/field-info/product-url-step3.*
        src: "/images/field-info/product-url-step3.png",
        alt: "올려줌에 주소 붙여넣기",
        width: 480,
        height: 240,
      },
    },
  ],
};

export const MAIN_KEYWORD_INFO = {
  title: "메인키워드 입력 안내",
  steps: [
    {
      id: "main-keyword-1",
      description:
        "검색량이 많으며, 상위노출을 시키고 싶으신 검색어입니다.\n(예시: 펩시 제로, 펩시, 콜라)",
      image: {
        // ← STEP1 이미지: public/images/field-info/main-keyword-step1.*
        src: "/images/field-info/main-keyword-step1.png",
        alt: "메인키워드 예시",
        width: 480,
        height: 280,
      },
    },
  ],
};

export const CATEGORY_NAME_INFO = {
  title: "카탈로그 상품명 입력 안내",
  steps: [
    {
      id: "catalog-name-1",
      description:
        "이미지와 같이 카탈로그 상품명을 복사하여\n올려줌 사이트에 입력해주세요.",
      image: {
        // ← STEP1 이미지: public/images/field-info/catalog-name-step1.*
        src: "/images/field-info/catalog-name-step1.png",
        alt: "카탈로그 상품명 복사",
        width: 480,
        height: 280,
      },
    },
  ],
};

export const CATEGORY_URL_INFO = {
  title: "카탈로그 상품 URL 주소 입력 안내",
  steps: [
    {
      id: "catalog-url-1",
      description:
        "네이버에 등록할 상품을 검색 후 카탈로그 상품 페이지에 들어가주세요.",
      image: {
        // ← STEP1 이미지: public/images/field-info/catalog-url-step1.*
        src: "/images/field-info/catalog-url-step1.png",
        alt: "카탈로그 상품 페이지 진입",
        width: 480,
        height: 280,
      },
    },
    {
      id: "catalog-url-2",
      description:
        "이미지와 같이 카탈로그 상품 페이지 상단 주소를 복사해주세요.",
      image: {
        // ← STEP2 이미지: public/images/field-info/catalog-url-step2.*
        src: "/images/field-info/catalog-url-step2.png",
        alt: "카탈로그 상품 페이지 상단 주소 복사",
        width: 480,
        height: 200,
      },
    },
    {
      id: "catalog-url-3",
      description:
        "올려줌 사이트에 돌아와서 복사한 주소를 붙여넣기 해주세요.",
      image: {
        // ← STEP3 이미지: public/images/field-info/catalog-url-step3.*
        src: "/images/field-info/catalog-url-step3.png",
        alt: "카탈로그 상품 URL 붙여넣기",
        width: 480,
        height: 240,
      },
    },
  ],
};
